import { restHeartClient } from "..";
import { Page } from '../interfaces/Page';
import { PageQuery } from '../interfaces/PageQuery';

export function queryPage<T>(api: string, query?: PageQuery) {
    return restHeartClient.get<Page<T>>(api, {
        params: {
            count: 1,
            page: query?.page,
            pagesize: query?.pagesize,
            filter:  JSON.stringify(query?.filter),
            sort: JSON.stringify(query?.sort),
            keys: JSON.stringify(query?.keys)
        }
    });
}
